import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CustomerModerationViewModel } from '../../shared/models/customer-moderation.model';

@Component({
  selector: 'app-customer-moderation-create',
  templateUrl: './customer-moderation-create.component.html',
  styleUrls: ['./customer-moderation-create.component.less'],
  standalone: false,
})
export class CustomerModerationCreateComponent {
  @Input() customer: CustomerModerationViewModel;
  @Output() approveCustomer: EventEmitter<string> = new EventEmitter<string>();
  @Output() rejectCustomer: EventEmitter<string> = new EventEmitter<string>();

  onApprove(customerModerationId) {
    this.approveCustomer.emit(customerModerationId);
  }

  onReject(customerModerationId) {
    this.rejectCustomer.emit(customerModerationId);
  }

  copyText(overlayPanel, event, activationLink) {
    overlayPanel.toggle(event);
    if (activationLink && navigator.clipboard) {
      navigator.clipboard.writeText(activationLink);
    } else {
      return this.copyWithExecCommand(activationLink);
    }
  }

  private copyWithExecCommand(text: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          resolve();
        } else {
          reject(new Error('Copy failed'));
        }
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }
}
